import { render, staticRenderFns } from "./updateStatusModal.vue?vue&type=template&id=22092376&"
import script from "./updateStatusModal.vue?vue&type=script&lang=js&"
export * from "./updateStatusModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22092376')) {
      api.createRecord('22092376', component.options)
    } else {
      api.reload('22092376', component.options)
    }
    module.hot.accept("./updateStatusModal.vue?vue&type=template&id=22092376&", function () {
      api.rerender('22092376', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/appointments/components/updateStatusModal.vue"
export default component.exports